import React, { useState, useEffect } from "react";
import "./EnquiryPopup.css";

const EnquiryPopup = ({ isOpen, onClose, productTitle }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    product: productTitle || "",
  });
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    setFormData((prev) => ({ ...prev, product: productTitle }));
  }, [productTitle]);

  const handleUserInput = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleUserSubmit = async (e) => {
    e.preventDefault();

    const formUrl =
      "https://docs.google.com/forms/d/e/1FAIpQLScCh_Wn_mi8GlNCFJg0xw82iFGq9m3a7Z2STUBKRA2sSh9TKQ/formResponse";

    const formDataToSend = {
      "entry.1812720550": formData.name,
      "entry.1870394174": formData.email,
      "entry.97349512": formData.phone,
      "entry.231532781": formData.message,
      "entry.1357408927": formData.product,
    };

    try {
      await fetch(formUrl, {
        method: "POST",
        mode: "no-cors",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formDataToSend).toString(),
      });

      setSubmitted(true);
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  return (
    isOpen && (
      <div className="enquiry-popup-overlay" onClick={onClose}>
        <div className="enquiry-popup" onClick={(e) => e.stopPropagation()}>
          <div className="enquiry-header">
            <div className="enquiry-title">Enquiry Form</div>
            <button className="close-button" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="enquiry-body">
            {submitted ? (
              <div className="message bot">
                Thank you for your query! We will get back to you shortly with
                an answer!
              </div>
            ) : (
              <form onSubmit={handleUserSubmit} className="message-form open">
                <label htmlFor="name">Please give us your name:</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleUserInput}
                  placeholder="Your Name"
                  required
                />
                <label htmlFor="email">
                  Give us an email where we can contact you:
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleUserInput}
                  placeholder="Your Email"
                  required
                />
                <label htmlFor="message">
                  Lastly, let us know what is your question:
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleUserInput}
                  placeholder="Your Message"
                  required
                ></textarea>
                <button className="submit-button" type="submit">
                  Submit
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default EnquiryPopup;
